import {
    ComponentManager,
    ControlFactory,
    CustomFilterChipBuilder,
    DetailViewContext,
    ListViewViewModel,
    RADEnvironmentProxy,
    ResourceManager,
    UIListener,
    openDownloadDialogFromApplicationAsync,
} from 'radpresentation.htmlclient.defaultviewextensions';
import { IListViewDTO, IOperationResultDTO } from 'coreframetypings/dto';
import LandesverbandWechselnDialogViewModel
    from '@/Components/LandesverbandWechseln/LandesverbandWechselnDialogViewModel';
import LandesverbandWechselnDialogWindow from '@/Components/LandesverbandWechseln/LandesverbandWechselnDialogWindow';
import UIListenerUtility from '@/Utils/UIListenerUtility';
import {
    getCustomNewcomerTitleErgName,
} from '@/Services/NewcomerStatus/startpageNewcomerFilters';

const SwitchLVOperation = 'SwitchLV';
const ExportLVOperation = 'ExportLV';

const NewcomerFilterChips: ReadonlyArray<{ ergName: string; statement: string; activeOnOpen: boolean }> = [
    { ergName: 'ONV.ONV.NEWCOMER_FILTER_AKTUELLE_ERGNAME', statement: "this.Archivstatus = 'NichtArchiviert' and this.Lizenzstatus = 'NichtLizensiert'", activeOnOpen: true },
    { ergName: 'ONV.ONV.NEWCOMER_FILTER_LIZENSIERTE_ERGNAME', statement: "this.Lizenzstatus = 'Lizensiert'", activeOnOpen: false },
    { ergName: 'ONV.ONV.NEWCOMER_FILTER_ARCHIVIERTE_ERGNAME', statement: "this.Archivstatus = 'Archiviert'", activeOnOpen: false },
    { ergName: 'ONV.ONV.NEWCOMER_FILTER_BEZAHLTE_ERGNAME', statement: 'this.IsBezahlt = true', activeOnOpen: false },
];

class NewcomerUIListener extends UIListener
{
    public override onBeforeListViewRender(context: ListViewViewModel, dto: IListViewDTO) {
        // Von der Startseite verlinkte, fest gefilterte Liste: eigenen Breadcrumb-Titel setzen
        // und die Standard-Filterchips weglassen (sie wuerden mit dem festen Filter kollidieren).
        const customErgName = getCustomNewcomerTitleErgName(context.filter);
        if (customErgName)
        {
            dto.ergNamePluralized = customErgName;
            return;
        }

        this.addDefaultFilterChips(context);
    }

    public override onDetailViewReady(context: DetailViewContext) {
        UIListenerUtility.disableControlViaOtherControl(context, 'WiedervorlageAktiv', 'Wiedervorlagedatum');
        this.makeReadonly(context);
    }

    public override onAfterApply(context: DetailViewContext, isClosing: boolean) {
        this.makeReadonly(context);
    }

    public override onBeforeCallOperation(context: any, operation: string): boolean | JQueryDeferred<boolean> | JQueryPromise<boolean> {
        if (operation !== SwitchLVOperation)
        {
            return super.onBeforeCallOperation(context, operation);
        }

        const newcomerPdoId = context.dataGrid.selected()[0] as string;
        if (!newcomerPdoId)
        {
            return false;
        }
        this.openLandesverbandWechselnDialogFromListView(newcomerPdoId, context);

        return false;
    }
    
    public onAfterCallOperation(context: DetailViewContext, operation: string, args: IOperationResultDTO) {
        if (operation === ExportLVOperation){
            if (!this.validateStatus(args))
            {
                return;
            }

            if (!args.returnValue)
            {
                return;
            }

            openDownloadDialogFromApplicationAsync(args.returnValue as string);
        }
        
        super.onAfterCallOperation(context, operation, args);
    }

    private openLandesverbandWechselnDialogFromListView(newcomerPdoId: string, listView: ListViewViewModel): void {
        const vm = new LandesverbandWechselnDialogViewModel({
            newcomerPdoId,
            onOk: (selectedLvPdoId: string) =>
            {
                RADEnvironmentProxy.getInstance().callStaticOperation({
                    pdTypeName: 'ONV.ONV.Newcomer',
                    operationName: 'SwitchLandesverbandById',
                    operationParameters: [newcomerPdoId, selectedLvPdoId],
                    contextParameters: {},
                }).then(() =>
                {
                    // Selektion leeren bevor Refresh, damit die SummaryView nicht
                    // mehr den gerade gewechselten Newcomer nachlädt (→ SecurityException).
                    listView.dataGrid.selected([]);
                    listView.refresh();
                });
            },
        });

        const win = new LandesverbandWechselnDialogWindow(vm);
        win.getTuple();
    }

    private addDefaultFilterChips(context: ListViewViewModel): void {
        const resourceManager = ResourceManager.getInstance();
        const existing = context.customFilterChips();

        const chipsToAdd = NewcomerFilterChips
            .map(chip => ({ displayName: resourceManager.get(chip.ergName), ...chip }))
            .filter(chip => !existing.some(e => e.displayName === chip.displayName))
            .map(chip => new CustomFilterChipBuilder(chip.displayName)
                .useFilterStatement(chip.statement)
                .isActiveOnOpen(chip.activeOnOpen)
                .build());

        if (chipsToAdd.length > 0)
        {
            context.appendCustomFilterChip(chipsToAdd);
        }
    }

    private makeReadonly(context: DetailViewContext) {
        const status = context.genericObject.getValue('Archivstatus.Value') as string;
        if (status && status === 'Archiviert')
        {
            UIListenerUtility.makeEverythingReadonly(context);
        }
    }
}

ComponentManager.setUIListener('NewcomerUIListener', NewcomerUIListener, 'ONVHTMLViewExtension');